import { Availability } from './Availability';
import { Field } from './Field';
import { Metadata } from './Metadata';
import { OptionGroup } from './OptionGroup';
import { OptionLabel } from './OptionLabel';

export class OptionImage {
    description: string | null;
    filename: string | null;
    groupname: string | null;
    isDefault: boolean;
    url: string | null;
}

export class Option {
    id: number;
    chainoptionid: number;
    displayid: number | null;
    name: string;
    isdefault: boolean;
    cost: number;
    children: boolean;
    modifiers: Array<OptionGroup> | null;
    fields: Array<Field> | null;
    menuitemlabels: Array<OptionLabel>;
    basecalories: string | null;
    maxcalories: string | null;
    caloriesseparator: string | null;
    adjustsparentprice: boolean;
    adjustsparentcalories: boolean;
    availability: Availability;
    metadata: Array<Metadata> | null;
    images: Array<OptionImage> | null;
}
